import { Box } from '@mui/material';
import SettingControl from 'components/SettingControl';
import { Switch } from 'components/Switch';
import { audioOnlyModeToggleRequested } from 'features/application/actions';
import { selectIsAudioOnlyMode } from 'features/application/applicationSlice';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'store/hooks';

const AudioOnlySetting = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('settings');

  const isAudioOnly = useAppSelector(selectIsAudioOnlyMode);

  const handleAudioOnlyChange = () => {
    dispatch(audioOnlyModeToggleRequested());
  };

  return (
    <Box sx={{ mt: 8 }}>
      <SettingControl
        label={t('video.audio_only_label')}
        helperText={t('video.audio_only_help')}
        alignItems="flex-start"
        control={
          <Switch
            onChange={handleAudioOnlyChange}
            checked={isAudioOnly}
            slotProps={{
              input: {
                'aria-label': isAudioOnly
                  ? t('video.audio_only_disable_aria_label')
                  : t('video.audio_only_enable_aria_label'),
              },
            }}
          />
        }
      />
    </Box>
  );
};

export default AudioOnlySetting;
